import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconSpecialCharacter = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="19.09"
    height="17.354"
    viewBox="0 0 19.09 17.354"
    {...props}
  >
    <g transform="translate(0 -21.333)">
      <g transform="translate(0 21.333)">
        <g transform="translate(0 0)">
          <path
            d="M10.3,32.678h0L8.1,30.5l.026-.026a15.2,15.2,0,0,0,3.219-5.666h2.542v-1.74H7.809V21.333H6.074v1.735H0V24.8H9.692a13.7,13.7,0,0,1-2.751,4.651,13.683,13.683,0,0,1-2-2.907H3.2A15.239,15.239,0,0,0,5.788,30.5l-4.412,4.36L2.6,36.084l4.339-4.339,2.7,2.7Z"
            transform="translate(0 -21.333)"
          />
          <path
            d="M240.306,192h-1.735l-3.9,10.413H236.4l.976-2.6H241.5l.976,2.6h1.735Zm-2.278,6.074,1.41-3.762,1.41,3.762Z"
            transform="translate(-225.121 -185.058)"
          />
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconSpecialCharacter)
